import React from 'react';
// import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { isSmallScreen } from 'utils/checkMedia.js';
import Form4Separate from 'components/interaction/Form4/Form4Separate.jsx';
import useSchoolSettings from '../../hooks/useSchoolSettings.js';
import messages from './messages.js';
import schema from './form.js';

function Account() {
  const { settings, changeDetail } = useSchoolSettings();

  return (
    <div className="mb-4">
      <h3><FormattedMessage {...messages.account} /></h3>
      <Form4Separate
        schema={schema}
        defaultValues={settings}
        onSubmit={changeDetail}
        labelWidth="7em"
        horizontal={!isSmallScreen()}
      />
    </div>
  );
}

export default Account;
